const MODAL_HEADING_ID = "modal-heading";
export {
  MODAL_HEADING_ID
};
